import module from 'module';
import _ from 'lodash';

import {cicContractTypes} from 'constants/loan';

const templateUrl = require('./new-loan-lai.template.html');
module.component('customerLoanCreateLaiDetails', {
  templateUrl: templateUrl,
  bindings: {
    formLai: '=',
    loanInformation: '=',
    collateralFiles: '=',
    validateFiles: '=',
    loanProduct: '<',
    hideMisGroup: '<',
    customerId: '=',
    formMap: '=',
    setDefaultValues: '<',
    hideCollateral: '<',
    groupLoan: '<'
  },
  controller: function ($scope, $timeout, dict, loanIndustryPurposeCache, misGroupsCache) {
    let that = this;
    that.dict = dict;

    that.$onInit = () => {
      if (that.setDefaultValues == null) that.setDefaultValues = true;

      that.setDefaults();
    };

    dict.onLoadingComplete(() => {
      that.loanSecurityClean = _.find(that.dict['LOAN_SECURITY'], {code: 'CLN'});
      that.visibleLoanSecurityOptions = that.hideCollateral ?
        that.dict.LOAN_SECURITY.filter(security => security.id === that.loanSecurityClean.id) :
        that.dict.LOAN_SECURITY;

      if (that.setDefaults) {
        that.setDefaults();
      }
    });

    that.updateLoanSecurityOptions = () => {
      that.visibleLoanSecurityOptions = that.dict.LOAN_SECURITY;
      if (that.loanProduct && that.loanProduct.withCollateral === false) {
        that.visibleLoanSecurityOptions = that.dict['LOAN_SECURITY'].filter(loanSec => loanSec.code === 'CLN');
      } else if (that.loanProduct && that.loanProduct.withCollateral === true) {
        that.visibleLoanSecurityOptions = that.dict['LOAN_SECURITY'].filter(loanSec => loanSec.code !== 'CLN');
      }
    };

    that.setDefaults = () => {
      if (!that.loanProduct || !that.setDefaultValues) return;

      if (that.loanInformation === undefined) {
        that.loanInformation = {};
      }
      if (that.loanProduct.defaultClassId) {
        let result = _.find(that.dict['LOAN_CLASS'], {id: that.loanProduct.defaultClassId});
        if (result) {
          that.loanInformation.loanClassId = result.id;
        }
      }
      if (that.loanProduct.defaultPurposeId) {
        let result = _.find(that.dict['LOAN_PURPOSE'], {id: that.loanProduct.defaultPurposeId});
        if (result) {
          that.loanInformation.loanPurposeId = result.id;
        }
      }
      if (that.loanProduct.defaultSecurityId) {
        let result = _.find(that.dict['LOAN_SECURITY'], {id: that.loanProduct.defaultSecurityId});
        if (result) {
          that.loanInformation.loanSecurityId = result.id;
        }
      }
      if (that.loanProduct.defaultEconomicActivityId) {
        let result = _.find(that.dict['LOAN_ECONOMIC_ACTIVITY'], {id: that.loanProduct.defaultEconomicActivityId});
        if (result) {
          that.loanInformation.loanEconomicActivityId = result.id;
        }
      }
      if (that.loanProduct.defaultLoanIndustryPurposeId) {
        that.loanInformation.loanIndustryPurposeId = that.loanProduct.defaultLoanIndustryPurposeId;
      }
      if (that.loanProduct.defaultMisGroupId) {
        that.loanInformation.misGroupId = that.loanProduct.defaultMisGroupId;
      }
      if (that.loanProduct.defaultMicrofinanceClassificationId) {
        that.loanInformation.loanMicrofinanceClassificationId = that.loanProduct.defaultMicrofinanceClassificationId;
      }
    };

    $scope.$watch('$ctrl.formLai.$invalid', () => {
      if (that.customerId) {
        that.formMap[that.customerId] = that.formLai.$valid;
      }
    });

    that.$onChanges = (changes) => {
      if (changes.loanProduct.currentValue) {
        that.loanProduct = changes.loanProduct.currentValue;
        that.updateLoanSecurityOptions();
        this.setDefaults();
      }
    };

    that.cicContractTypes = [...cicContractTypes];

    // loan industry purpose
    that.loanIndustryPurposeSelected = null;

    that.loanIndustryPurposeTreeVisible = false;
    that.showLoanIndustryPurposeButton = ($event) => {
      that.loanIndustryPurposeTreeVisible = true;
      $event.stopPropagation();
    };

    that.loanIndustryPurposeSelected = (selected) => {
      if (selected.children.length === 0) {
        that.loanInformation.loanIndustryPurposeId = selected.id;
        that.loanIndustryPurposeTreeVisible = false;
      }
    };


    let loanPurposeSubscr = loanIndustryPurposeCache.toObservable().subscribe((groups) => {
        // build mis groups hierarchy
        let root = [];
        let idMap = {};
        buildHierarchy(groups, idMap, root);

        that.availableLoanIndustryPurposeGroups = root;
        that.loanIndustryPurposeIdMap = idMap;
      }
    );

    let misSubscr = misGroupsCache.toObservable().subscribe((groups) => {
        // build mis groups hierarchy
        let root = [];
        let idMap = {};
        buildHierarchy(groups, idMap, root);

        that.availableMisGroups = root;
        that.misGroupIdMap = idMap;
      }
    );

    function buildHierarchy(groups, idMap, root) {
      let codeMap = {};
      // first pass - populate code map
      for (let group of groups) {
        codeMap[group.code] = group;
        idMap[group.id] = group;
        group.children = [];
      }

      // second pass - build hierarchy based on map
      for (let group of groups) {
        if (group.parentCode) {
          const parent = codeMap[group.parentCode];
          parent.children.push(group);
        } else {
          root.push(group);
        }
      }
    }

    // mis groups
    that.misSelected = null;

    that.misTreeVisible = false;
    that.showMisButton = ($event) => {
      that.misTreeVisible = true;
      $event.stopPropagation();
    };

    that.misGroupSelected = (selected) => {

      if (selected.children.length === 0) {
        that.loanInformation.misGroupId = selected.id;
        that.misTreeVisible = false;
      }
    };

    that.misColDefs = [{field: "name"}];

    that.$onDestroy = () => {
      misSubscr.unsubscribe();
      loanPurposeSubscr.unsubscribe();
    };

  }
});
